"use strict";

exports.__esModule = true;
exports.SurfaceWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _EditableSurfaceElement = require("./EditableSurfaceElement");
var _SurfaceElement = require("./SurfaceElement");
var _SurfaceFields = require("./SurfaceFields");
var _SurfaceHeader = require("./SurfaceHeader");
var _SurfaceThumbnail = require("./SurfaceThumbnail");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SurfaceWidget = exports.SurfaceWidget = {
  name: "Surface",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "SurfaceWidget.label",
    defaultMessage: "Surface"
  }),
  icon: "layer",
  createElement: function createElement(props) {
    return {
      type: "Surface",
      props: Object.assign({
        width: 1024,
        height: 768
      }, props),
      children: []
    };
  },
  showInPalette: false,
  isParent: true,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: [],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 1024,
      min: 128,
      max: 3840
    },
    height: {
      "default": 768,
      min: 128,
      max: 2160
    }
  },
  components: {
    Header: _SurfaceHeader.SurfaceHeader,
    Element: _SurfaceElement.SurfaceElement,
    Fields: _SurfaceFields.SurfaceFields,
    Editable: _EditableSurfaceElement.EditableSurfaceElement,
    Thumbnail: _SurfaceThumbnail.SurfaceThumbnail
  }
};